import { FC } from 'react';

import { FormTabs } from 'components';
import { Stack } from 'libs/ui';
import { ClientMainInfo } from 'modules/client/common/components/ClientMainInfo';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';

import { LegalClientSectionsProps } from './types';
import { useLegalClientSections } from './useLegalClientSections';

export const LegalClientSections: FC<LegalClientSectionsProps> = ({
  countryRiskAt,
  ...props
}) => {
  const { tabs, info } = useLegalClientSections(props);

  return (
    <CountryRiskProvider at={countryRiskAt} role={CountryRiskRole.LegalClient}>
      <Stack spacing={36}>
        {info && <ClientMainInfo info={info} />}

        <FormTabs tabs={tabs} />
      </Stack>
    </CountryRiskProvider>
  );
};
